<template>
  <v-container>
    <v-subheader>Yellow stationData</v-subheader>
    <c-data-list v-model="stationData" />
    <v-subheader>Yellow stationData - calculated</v-subheader>
    <c-data-list v-model="calculatedParams" />
    <v-subheader>Constants</v-subheader>
    <c-data-list v-model="constants" />
    <v-subheader>Green Cells</v-subheader>
    <c-data-list v-model="output" />
  </v-container>
</template>
<script>
export default {
  name: 'CalculatedDemo',
  created () {
    const today = new Date()
    console.log(Math.ceil((today - new Date(today.getFullYear(), 0, 1)) / 86400000))
  },
  computed: {
    julianDate () {
      const today = new Date()
      return Math.ceil((today - new Date(today.getFullYear(), 0, 1)) / 86400000)
    },
    calculatedParams () {
      return [
        {
          label: 'Latitude (decimal)',
          value: (this.stationData[5].value + this.stationData[6].value) / 60
        },
        {
          label: 'Latitude (radians)',
          value: (3.14159 / 180) * (this.stationData[5].value + this.stationData[6].value) / 60
        },
        {
          label: 'Tmax (degK)',
          value: this.observeData[0].value + 273.16
        },
        {
          label: 'Tmin (degK)',
          value: this.observeData[1].value + 273.16
        }
      ]
    },
    output () {
      return [
        {
          label: 'Ws_2m (m/s)',
          value: (4.87 / Math.log(67.8 * this.stationData[1].value - 5.42)) * this.calculatedParams[3].value
        },
        {
          label: 'Tavg (degC)',
          value: (this.observeData[0].value + this.observeData[1].value) / 2
        },
        {
          label: 'Delta(msvp)',
          value: ''
        },
        {
          label: 'P (at alt.)',
          value: 101.3 * ((293 - (0.0065 * this.stationData[2].value)) / 293) ^ 5.26
        },
        {
          label: 'Gamma',
          value: ''
        },
        {
          label: 'e0(Tmax)',
          value: ''
        },
        {
          label: 'e0(Tmin)',
          value: ''
        },
        {
          label: 'es',
          value: ''
        },
        {
          label: 'ea',
          value: ''
        },
        {
          label: 'es - ea',
          value: ''
        },
        {
          label: 'dr',
          value: ''
        },
        {
          label: 'Delta(sc)',
          value: ''
        },
        {
          label: '...',
          value: '...'
        }
      ]
    },
    ws2m () {
      return (4.87 / Math.log(67.8 * this.stationData[1].value - 5.42)) * this.calculatedParams[3].value
    },
    tvag () {
      return (this.stationData[7].value + this.stationData[8].value) / 2
    },
    delta () {
      return (4098 * (0.6108 * Math.exp((17.27 * this.tvag) / (this.tvag + 237.3))) / (this.tvag + 237.3) ^ 2)
    },
    p () {
      return 101.3 * ((293 - (0.0065 * this.stationData[2])) / 293) ^ 5.26
    },
    gamma () {
      return this.constants[1] * this.p
    },
    e0TMax () {
      return 0.6108 * Math.exp(17.27 * this.stationData[0] / (this.stationData[0] + 237.3))
    },
    e0TMin () {
      return 0.6108 * Math.exp(17.27 * this.stationData[1] / (this.stationData[1] + 237.3))
    },
    es () {
      return (this.e0TMax + this.e0TMin) / 2
    },
    ea () {
      return (1.431 * (this.stationData[2] / 100) + 2.564 * this.stationData[3] / 100) / 2
    },
    esea () {
      return this.es - this.ea
    },
    dr () {
      return 1
      // + 0.033 * Math.cos(2 * 3.14159 / 365 * E2)
    }
  },
  data () {
    return {
      stationData: [
        {
          label: 'Ws height (m)',
          value: 10
        },
        {
          label: 'Sunshine (h)',
          value: 9.25
        },
        {
          label: 'Altitude (m)',
          value: 100
        },
        {
          label: 'Altitude (m)',
          value: 100.1
        },
        {
          label: 'Julian Day',
          value: 157
        },
        {
          label: 'Latitude (deg)',
          value: 50
        },
        {
          label: 'Latitude (min)',
          value: 48
        }
      ],
      observeData: [
        {
          label: 'Tmax (degC)',
          value: 21.5
        },
        {
          label: 'Tmin (degC)',
          value: 12.3
        },
        {
          label: 'Rhmax (%)',
          value: 84
        },
        {
          label: 'Rhmin (%)',
          value: 63
        },
        {
          label: 'Ws (km/h)',
          value: 10
        },
        {
          label: 'Ws_10m (m/s)',
          value: 2.7777
        }
      ],
      constants: [
        {
          label: 'Solar constant (Gsc)',
          value: 0.082
        },
        {
          label: 'Gamma constant (kPa/degC)',
          value: 0.000665
        },
        {
          label: 'Albedo',
          value: 0.23
        },
        {
          label: 'Stefan-Boltzmann',
          value: 0.000000004903
        },
        {
          label: 'G (soil heat flux)',
          value: 0
        }
      ]
    }
  }
}
</script>
